/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useState, useEffect } from 'react';
import { Route, useRouteMatch, Switch, Redirect } from 'react-router-dom';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import { GlobalLoaderContext } from 'store/context';
import { useHistory } from 'react-router-dom';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { Layout } from 'components';
import { Content, Heading } from './styles';
import { Field, Form, Formik, FieldArray, Form as Formikform } from 'formik';
import { Col, Row } from 'components/Grid';
import {
    InputField,
    Label,
    MultiSelectField,
    Section,
    SectionHeader,
    SectionLegend,
    SectionTitle,
    SelectField,
    GridColumnTitle
  } from 'components/Form';
import * as Yup from 'yup';
import { FitinsurAPI ,MessageCenter} from 'utils';
import { FitinsurAPIMockup } from 'utils';


export default function RenewPage() { 
    const loading = useContext(GlobalLoaderContext);
    const authContext = useContext(GlobalAuthContext);
    const operationContext = useContext(GlobalOperationContext);
    const match = useRouteMatch();
    const history = useHistory();

  useEffect(() => {
    
  }, [ ]);  
    
  const goToHomePage = () => {
    history.push('/home');
  };

  const goToLoginPage = () => {
    history.push('/login');
  };

  // main execution
  const fitinsur = new FitinsurAPI();
const mc = new MessageCenter();
  //const fitinsur = new FitinsurAPIMockup();

   if (authContext.status !== true) {
     mc.error("User is not authenticated, please Login");
     goToLoginPage();
   } else {
     fitinsur.setAuthToken(authContext.token);
   }

    return (
        <>
        <Layout title={'Renewals - TITLE'} subtitle={'Renewals - SUBTITLE'}>
            <Content>                
                <Heading>{'Renewals - CONTENT HEADING'}</Heading>
      <>

            <Formik
              initialValues={{

              }}

              validationSchema={Yup.object({

              })}

              onSubmit={values => {
                
              }}
            >

              {(props) => (
                <Form>

                  <>
                    <Section>
                      <Row>
                        <Col xs={12} md={12}>
                          <Label>UNDER CONSTRUCTION</Label>
                        </Col>
                      </Row>                       
                    </Section>
                  </>

                </Form>
              )}

            </Formik>

            {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
          </>

            </Content>                
        </Layout>
        </>
    );
}